/**
 * [PROD-1205] What the embed says while a turn is in flight.
 *
 * Mirrors Agent desktop's `thinkingLabel`
 * (apps/agent/client/src/lib/thinking-indicator.ts) so the two surfaces
 * speak the same language — the embed used to show a flat "Generating…".
 * Kept as a pure function because this package has no DOM harness; the
 * component that renders it can't be unit-tested, this can.
 *
 * Desktop's silence escalation ("Still thinking…" at 25s, "This is taking
 * longer than usual" at 60s, the View-trace link at 120s) is deliberately
 * left out: it needs a timer + the trace panel, neither of which the embed
 * has. Port it if the palette ever grows one.
 */
import { formatToolCallStatus } from '@ordo/agent-tools/tool-status'

import type { TurnState } from '../types'

export function thinkingLabel(args: {
  turnState: TurnState
  liveActivity: { slug: string; args: unknown } | null
}): string {
  const { turnState, liveActivity } = args
  // Naming the running tool beats a generic phase label on pool turns, where
  // this line is the only place their activity shows. Falls back the moment
  // the tool finishes (`liveActivity: null`).
  if (liveActivity) {
    return formatToolCallStatus(liveActivity.slug, liveActivity.args)
  }
  return turnState === 'sending' ? 'Sending…' : turnState === 'awaiting' ? 'Connecting…' : 'Thinking…'
}
